interface Props {
  aoDigitar: (digito: string) => void;
  aoApagar: () => void;
  aoOk: () => void;
  rotuloOk: string;
  okDesabilitado?: boolean;
}

const DIGITOS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

// Teclado numérico grande, com o dedão. Usado na quantidade e no dinheiro.
export default function TecladoNumero({
  aoDigitar,
  aoApagar,
  aoOk,
  rotuloOk,
  okDesabilitado = false,
}: Props) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {DIGITOS.map((d) => (
        <button
          key={d}
          type="button"
          onClick={() => aoDigitar(d)}
          className="flex h-14 cursor-pointer select-none items-center justify-center rounded-xl border border-secondary-200 bg-white text-2xl font-bold text-foreground-950 transition-colors hover:bg-background-100 active:bg-background-200"
        >
          {d}
        </button>
      ))}
      <button
        type="button"
        onClick={aoApagar}
        aria-label="Apagar"
        className="flex h-14 cursor-pointer select-none items-center justify-center rounded-xl border border-secondary-200 bg-white text-foreground-700 transition-colors hover:bg-background-100 active:bg-background-200"
      >
        <i className="ri-delete-back-2-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => aoDigitar('0')}
        className="flex h-14 cursor-pointer select-none items-center justify-center rounded-xl border border-secondary-200 bg-white text-2xl font-bold text-foreground-950 transition-colors hover:bg-background-100 active:bg-background-200"
      >
        0
      </button>
      <button
        type="button"
        onClick={aoOk}
        disabled={okDesabilitado}
        className="flex h-14 cursor-pointer select-none items-center justify-center rounded-xl bg-primary-500 text-base font-bold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        {rotuloOk}
      </button>
    </div>
  );
}